module.exports = __webpack_public_path__ + "static/img/service_passprime_icon_3.4323db23.svg";